import React, { useState, useEffect } from "react";
import { MdPerson, MdVerified } from "react-icons/md";
import Banner from "./components/Banner";
// import General from "./components/General";
// import Notification from "./components/Notification";
import Project from "./components/Project";
// import Storage from "./components/Storage";
import api from "../../../services/axios";
import SkeletonTable from "../../../components/skeleton/table";
import {
  CountProject,
  CountTimeSheetApproved,
  CountTimeSheetInAnalysis,
  CountTimeSheetInProgress,
  SumWorkHours,
} from "../../../utils/mathUtils";
// import Upload from "./components/Upload";

const ProfileOverview = () => {
  const [projectDetail, setProjectDetail] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [projectCount, setProjectCount] = useState<number>(0);
  const [hourSum, setHourSum] = useState<any>(0);
  const [projectTimeSheetApproved, setProjectTimeSheetApproved] =
    useState<number>(0);
  const [projectTimeSheetInProgress, setProjectTimeSheetInProgress] =
    useState<number>(0);
  const [projectTimeSheetInAnalysis, setProjectTimeSheetInAnalysis] =
    useState<number>(0);

  useEffect(() => {
    setLoading(true);
    // Employee project data
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    getWorkedHours(currentMonth, currentYear, null);
  }, []);

  const getWorkedHours = async (
    month: Number,
    year: Number,
    clientId: number | null
  ) => {
    setLoading(true);
    api
      .get(`/TimeManagement/GetWorkedHours?month=${month}&year=${year}`)
      .then((response) => {
        console.log(response.data);
        const dataSetArray = [];
        const projectDetailArray = [];
        response.data.forEach((element) => {
          //dataset Banner
          const dataSet = {
            ProjectId: element.projectId,
            TotalHours: element.totalHours,
            StatusId: element.statusId,
          };
          dataSetArray.push(dataSet);

          //ProjectDetail
          const projectDetail = {
            NmProject: element.nmProject,
            NmCorporate: element.nmCorporate,
            TotalHour: element.totalHours,
          };
          projectDetailArray.push(projectDetail);
        });

        setProjectCount(CountProject(dataSetArray));
        setProjectTimeSheetApproved(CountTimeSheetApproved(dataSetArray));
        setProjectTimeSheetInProgress(CountTimeSheetInProgress(dataSetArray));
        setHourSum(SumWorkHours(dataSetArray));
        setProjectTimeSheetInAnalysis(CountTimeSheetInAnalysis(dataSetArray));
        setProjectDetail(projectDetailArray);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoading(false);
      });
  };

  return (
    <div className="mt-5">
      {loading ? (
        <SkeletonTable active={loading} />
      ) : (
        <div className="animate-fade-up flex w-full flex-col gap-5">
          {/* Page header */}
          <div className="flex items-center gap-3">
            <span
              className="dv-aura flex h-11 w-11 items-center justify-center rounded-2xl bg-dv-gradient text-white shadow-dv-glow"
              aria-hidden="true"
            >
              <MdPerson className="h-6 w-6" />
            </span>
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-dv-blue-500/10 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.18em] text-dv-blue-600 dark:text-dv-cyan-300">
                <MdVerified className="h-3.5 w-3.5" aria-hidden="true" />
                Meu perfil
              </span>
              <h1 className="mt-1.5 text-2xl font-extrabold tracking-tight text-navy-700 dark:text-white">
                Visão geral do perfil
              </h1>
            </div>
          </div>

          <div className="w-full flex h-fit flex-col gap-6 lg:grid lg:grid-cols-8">
            <div className="col-span-8 lg:!mb-0">
              <Banner
                projectCount={projectCount}
                hourSum={hourSum}
                projectTimeSheetApproved={projectTimeSheetApproved}
                projectTimeSheetInProgress={projectTimeSheetInProgress}
                projectTimeSheetInAnalysis={projectTimeSheetInAnalysis}
              />
            </div>

            {/* <div className="col-span-4 lg:!mb-0">
              <Storage />
            </div> */}

            {/* <div className="z-0 col-span-5 lg:!mb-0">
              <Upload />
            </div> */}
          </div>
          {/* all project & ... */}

          <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">
            <div className="col-span-12 lg:col-span-12 lg:mb-0 3xl:col-span-12">
              <Project projectDetail={projectDetail} />
            </div>
            {/* <div className="col-span-6 lg:col-span-6 lg:mb-0 3xl:col-span-6">
              <General />
            </div> */}

            {/* <div className="col-span-5 lg:col-span-12 lg:mb-0 3xl:!col-span-3">
              <Notification />
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileOverview;
